/**
 * Local storage utilities for ChatWidget
 */

// Storage functions (copied from utils/StorageVariables.js)
const getCookie = (key: string): string | null => {
  return localStorage.getItem(key);
};

const setCookie = (key: string, value: string): void => {
  localStorage.setItem(key, value);
};

const removeCookie = (key: string): void => {
  localStorage.removeItem(key);
};

// Chat widget position storage utilities
const CHAT_WIDGET_POSITION_KEY = 'chatWidgetPosition';

/**
 * Save chat widget position to localStorage
 */
export const saveChatWidgetPosition = (position: { x: number }): void => {
  setCookie(CHAT_WIDGET_POSITION_KEY, JSON.stringify(position));
};

/**
 * Load chat widget position from localStorage
 */
export const loadChatWidgetPosition = (): { x: number } | null => {
  const saved = getCookie(CHAT_WIDGET_POSITION_KEY);
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (error) {
      console.warn('Failed to parse saved chat widget position:', error);
      removeCookie(CHAT_WIDGET_POSITION_KEY);
    }
  }
  return null;
};

/**
 * Remove saved chat widget position
 */
export const removeChatWidgetPosition = (): void => {
  removeCookie(CHAT_WIDGET_POSITION_KEY);
};